import { FC, useState } from 'react';
import { Props } from './types';
import classes from './OutputContainer.module.scss';
import { Button, ButtonGroup } from '@mui/material';
import { TableOutput } from '../TableOutput';
import { JSONOutput } from '../JSONOutput';

export const OutputContainer: FC<Props> = ({ processingData, formData }) => {
  const [tabularView, setTabularView] = useState(true);

  return (
    <div className={classes.wrapper}>
      <div className={classes.imageWrapper}>
        {processingData && (
          <>
            {processingData.capture.snapshots[0].url.includes('.pdf?') ? (
                <embed
                  src={processingData.capture.snapshots[0].url}
                  type="application/pdf"
                  height="100%"
                  width="100%"
                />
            ) : (
              <img className={classes.image} src={processingData.capture.snapshots[0].url} alt="" />
            )}
          </>
        )}
      </div>
      <div className={classes.dataWrapper}>
        <div className={classes.btns}>
          <ButtonGroup size="small" variant="outlined">
            <Button
              disabled={!processingData}
              className={tabularView ? classes.activeTab : undefined}
              onClick={() => setTabularView(true)}>
              Visualized Data
            </Button>
            <Button
              disabled={!processingData}
              className={tabularView ? undefined : classes.activeTab}
              onClick={() => setTabularView(false)}>
              Standardized JSON
            </Button>
          </ButtonGroup>

          <Button
            disabled={!processingData}
            size="small"
            variant="outlined"
            onClick={() => {
              const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(processingData));
              const downloadAnchorNode = document.createElement('a');
              downloadAnchorNode.setAttribute("href",     dataStr);
              downloadAnchorNode.setAttribute("download", Date.now() + ".json");
              document.body.appendChild(downloadAnchorNode);
              downloadAnchorNode.click();
              downloadAnchorNode.remove();
            }}
          >
            Download as JSON File
          </Button>
        </div>

        <div className={classes.dataContainer}>
          {processingData && (
            <>
              {formData?.purchaseValidation && (
                <div className={classes.formData}>
                  <div className={classes.productName}>
                    <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.85355 7.14645C7.65829 6.95118 7.34171 6.95118 7.14645 7.14645C6.95118 7.34171 6.95118 7.65829 7.14645 7.85355L7.85355 7.14645ZM10.1464 10.8536C10.3417 11.0488 10.6583 11.0488 10.8536 10.8536C11.0488 10.6583 11.0488 10.3417 10.8536 10.1464L10.1464 10.8536ZM5 8C3.34315 8 2 6.65685 2 5H1C1 7.20914 2.79086 9 5 9V8ZM2 5C2 3.34315 3.34315 2 5 2V1C2.79086 1 1 2.79086 1 5H2ZM5 2C6.65685 2 8 3.34315 8 5H9C9 2.79086 7.20914 1 5 1V2ZM8 5C8 6.65685 6.65685 8 5 8V9C7.20914 9 9 7.20914 9 5H8ZM7.14645 7.85355L10.1464 10.8536L10.8536 10.1464L7.85355 7.14645L7.14645 7.85355Z" fill="#CFCFCF"/>
                    </svg>

                    {formData?.productName}
                  </div>
                  {formData?.gtin && <div className={classes.gtin}>{formData?.gtin}</div>}
                </div>
              )}

              <div className={classes.outputContainer}>
                <div className={classes.content}>
                  {tabularView ?
                    <TableOutput processingData={processingData} formData={formData} /> :
                    <JSONOutput processingData={processingData} />}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
